<template>
    <div class="organizer-detail">
        <Nav />
        <div class="organizer-detail-container">
            <div class="title">
                <h3><em></em><span>{{ $t('organizer.title') }}</span><em></em></h3>
            </div>
            <div class="organizer-detail-content">
                <div class="organizer-detail-content-left">
                    <img :src="require('@/assets/organizers/' + organizer.img)" alt="">
                </div>
                <div class="organizer-detail-content-right">
                    <h4>{{ $t('organizer.details.' + id + '.name') }}</h4>
                    <!-- <p>{{ $t('organizer.details.' + id + '.desc') }}</p> -->
                    <div class="organizer-detail-content-right-bios">
                        <div v-for="(bio, index) in organizer.bios" :key="index">
                            <p>{{ bio }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <GoHome />
        </div>
        <Footer />
    </div>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { computed, onMounted } from 'vue'
import Nav from '@/components/Nav.vue'
import Footer from '@/components/Footer.vue'
import GoHome from '@/components/GoHome.vue'

const route = useRoute()
const { t, locale } = useI18n()
const id = route.params.id

const organizer = computed(() => {
    const details = {}
    details.img = t(`organizer.details.${id}.img`)
    details.name = t(`organizer.details.${id}.name`)
    details.desc = t(`organizer.details.${id}.desc`)
    details.bios = []
    for (let i = 1; i <= 6; i++) {
        const bioKey = `organizer.details.${id}.bio${i}`
        const bio = t(bioKey)
        if (bio !== bioKey) {  // Check if translation exists
            details.bios.push(bio)
        }
    }
    return details
})

onMounted(() => {
    localStorage.setItem('language', 'en')
    locale.value = 'en'
})

document.title = t('common.title')
</script>

<style scoped lang="scss">
.organizer-detail-container {
    max-width: 1440px;
    margin: 0 auto;
    padding: 50px 20px;

    .title {
        h3 {
            font-size: 36px;
            font-weight: bold;
            text-align: center;
            color: #333;
            margin-bottom: 60px;
            line-height: 1.2;

            span {
                margin: 0 40px;
            }

            em {
                display: inline-block;
                width: 54px;
                height: 14px;
                margin-bottom: 10px;
                background: url('@/assets/tt.png');
                vertical-align: middle;
            }
        }
    }

    .organizer-detail-content {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 50px;
        padding-bottom: 100px;

        border-bottom: 1px solid #eee;

        .organizer-detail-content-left {
            img {
                width: 280px;
                height: auto;
            }
        }

        .organizer-detail-content-right {
            h4 {
                font-size: 30px;
                font-weight: 400;
                color: #303030;
                margin-bottom: 20px;
            }

            p {
                font-size: 14px;
                color: #303030;
                margin-bottom: 0px;
            }
        }
    }


}

@media (max-width: 768px) {
    .organizer-detail-container {
        padding: 40px 10px;

        .title {
            em {
                margin-bottom: 0 !important;
                width: 40px !important;
            }

            span {
                font-size: 22px;
                margin: 0 10px !important;
            }
        }

        .organizer-detail-content {
            flex-direction: row;
            align-items: top;
            gap: 20px;

            .organizer-detail-content-left {
                img {
                    width: 100%;
                    height: auto;
                }
            }

            .organizer-detail-content-right {
                h4 {
                    font-size: 24px;
                }

                p {
                    font-size: 14px;
                }
            }
        }
    }
}
</style>
